import { useRef } from 'react';

import { randomUUID } from 'expo-crypto';
import { useDonations } from 'features/cart/hooks/use-donations';
import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { AlertDialog } from 'native-base';
import { Text } from 'react-native';

import { StyledToggleButtonGroup } from 'pages/cart/donation-at-checkout/styled';
import { useUIContext } from 'state/ui';
import { emptySanityImage } from 'utils/sanity';

export const CartDebugManageDonationsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const cancelRef = useRef(null);
  const { donations, loading } = useDonations();
  const { formatCurrencyForLocale } = useUIContext();
  const { cartEntries, addItemToMinimalCart, removeItemFromMinimalCart } = useMinimalCart();
  const selectedDonation: ICartEntry | undefined = cartEntries.find(
    entry => entry.type === MinimalCartEntryType.donation
  );

  const donationOptions = donations.map(donation => ({
    label: formatCurrencyForLocale(donation.price),
    value: donation.id,
    isDisabled: false,
  }));

  const handleChange = (value: string) => {
    if (selectedDonation?.id === value) {
      removeItemFromMinimalCart(selectedDonation);
      return;
    }
    const donation = donations.find(donation => donation.id === value);
    if (!donation) {
      return;
    }
    addItemToMinimalCart({
      id: value,
      cartId: randomUUID(),
      quantity: 1,
      name: donation.name,
      price: {
        amount: donation.price,
        currency: 'USD',
      },
      image: emptySanityImage(),
      url: '',
      type: MinimalCartEntryType.donation,
      children: [],
    });
  };

  return (
    <AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose}>
      <AlertDialog.Content>
        <AlertDialog.CloseButton />
        <AlertDialog.Header>Choose Donations</AlertDialog.Header>
        <AlertDialog.Body>
          {loading ? (
            <Text>Loading...</Text>
          ) : (
            <StyledToggleButtonGroup
              options={donationOptions}
              onChangeValue={handleChange}
              value={selectedDonation?.id}
              accessibilityHint={'Select Donation'}
              accessibilityLabel={'Select Donation'}
              isDisabled={loading}
            />
          )}
        </AlertDialog.Body>
      </AlertDialog.Content>
    </AlertDialog>
  );
};
